import { AudiometryAnswerType } from "app/types";
import { AudiometryAnswerService } from "../AudiometriaAnswerService";
import { CRUDApiService } from "./CRUDApiService";

export class AudiometryAnswerApiService extends CRUDApiService implements AudiometryAnswerService {
  constructor() {
    super("quizansweraudiometria");
  }

  async getByAccountId(accountId: number): Promise<AudiometryAnswerType[]> {
    const config = {
      method: "GET",
      url: `/getquizansweraudiometriaby/${accountId}`,
    };
    return this.makeHttpRequest(config);
  }
}
